import axios from "../instance";

export default {
    getAll: (companyId) => {
        if (companyId) {
            return axios.api.get(`/storeTypes?companyId=${companyId}`).then((response) => response.data);
        } else {

            return axios.api.get(`/storeTypes`).then((response) => response.data);
        }

    },
    getOne: (id) => {
        return axios.api.get(`/storeTypes/${id}`).then((response) => response.data);
    },
    search: (body) => {
        return axios.api.post("/storeTypes/search", body).then((response) => response.data);
    },
    create: (body) => {
        return axios.api.post("/storeTypes", body).then((response) => response.data);
    },
    update: (id, body) => {
        return axios.api.put(`/storeTypes/${id}`, body).then((response) => response.data);
    },
    delete: (id) => {
        return axios.api.delete(`/storeTypes/${id}`).then((response) => response.data);
    }
};
